// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.header {
  position: fixed;
  top: 0;
  width: 100%;
  padding: 1rem 3%;
  background-color: #f7f2f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 11;
}
#check {
  display: none;
}
.navbar a {
  font-size: 1.15rem;
  text-decoration: none;
  font-weight: 500;
  margin-left: 2.5rem;
  color: black;
  padding: 0.2rem;
  position: relative;
}
.navbar .navbar-link::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 0.175rem;
  background-color: rgb(69, 7, 126);
  left: 0;
  bottom: 0;
  transform: scale(0, 1);
  transition: transform 0.3s ease;
}
.navbar .navbar-link:hover::after {
  transform: scale(1, 1);
}
.navbar .navbar-link:hover {
  color: rgb(69, 7, 126);
}

.navbar a span {
  color: white;
}
.btns-login {
  background-color: rgb(69, 7, 126);
  color: white;
  border-radius: 0.4rem;
  width: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icons {
  position: absolute;
  right: 5%;
  font-size: 2rem;
  cursor: pointer;
  display: none;
}

.icons .menu-icon {
    display: block; /* Initially show the menu icon */
  }
  
  .icons .closed-icon {
    display: none; /* Initially hide the close icon */
  }
  
  #check:checked ~ .icons .menu-icon {
    display: none; /* Hide menu icon when checkbox is checked */
  }
  
  #check:checked ~ .icons .closed-icon {
    display: block; /* Show close icon when checkbox is checked */
  }

/* ***Breakpoints******* */

@media (max-width: 1200px) {
    .header {
      padding: 0.5rem 1%;
    }
    .icons {
      display: inline-flex;
    }
    .navbar {
      position: absolute;
      left: -100%;
      top: 0;
      width: 70%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      line-height: 40px;
      background-color: white;
      transition: 0.9s ease-out;
    }
    .btns-login {
      text-align: center;
    }
    .navbar a {
      border-bottom: 1px solid grey;
      margin: 0.5rem 0.4rem;
    }
    .icons .menu-icon {
      display: block;
    }
    .icons .closed-icon {
      display: none;
    }
    #check:checked ~ .icons .menu-icon {
      display: none;
    }
    #check:checked ~ .icons .closed-icon {
      display: block;
    }
    #check:checked ~ .navbar {
      left: 0;
      transition: 0.5s ease;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,OAAO;EACP,SAAS;EACT,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;IACI,cAAc,EAAE,iCAAiC;EACnD;;EAEA;IACE,aAAa,EAAE,kCAAkC;EACnD;;EAEA;IACE,aAAa,EAAE,4CAA4C;EAC7D;;EAEA;IACE,cAAc,EAAE,6CAA6C;EAC/D;;AAEF,0BAA0B;;AAE1B;IACI;MACE,kBAAkB;IACpB;IACA;MACE,oBAAoB;IACtB;IACA;MACE,kBAAkB;MAClB,WAAW;MACX,MAAM;MACN,UAAU;MACV,aAAa;MACb,aAAa;MACb,sBAAsB;MACtB,iBAAiB;MACjB,uBAAuB;MACvB,yBAAyB;IAC3B;IACA;MACE,kBAAkB;IACpB;IACA;MACE,6BAA6B;MAC7B,qBAAqB;IACvB;IACA;MACE,cAAc;IAChB;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;MACE,cAAc;IAChB;IACA;MACE,OAAO;MACP,qBAAqB;IACvB;EACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.header {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  padding: 1rem 3%;\n  background-color: #f7f2f9;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 11;\n}\n#check {\n  display: none;\n}\n.navbar a {\n  font-size: 1.15rem;\n  text-decoration: none;\n  font-weight: 500;\n  margin-left: 2.5rem;\n  color: black;\n  padding: 0.2rem;\n  position: relative;\n}\n.navbar .navbar-link::after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 0.175rem;\n  background-color: rgb(69, 7, 126);\n  left: 0;\n  bottom: 0;\n  transform: scale(0, 1);\n  transition: transform 0.3s ease;\n}\n.navbar .navbar-link:hover::after {\n  transform: scale(1, 1);\n}\n.navbar .navbar-link:hover {\n  color: rgb(69, 7, 126);\n}\n\n.navbar a span {\n  color: white;\n}\n.btns-login {\n  background-color: rgb(69, 7, 126);\n  color: white;\n  border-radius: 0.4rem;\n  width: 10rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.icons {\n  position: absolute;\n  right: 5%;\n  font-size: 2rem;\n  cursor: pointer;\n  display: none;\n}\n\n.icons .menu-icon {\n    display: block; /* Initially show the menu icon */\n  }\n  \n  .icons .closed-icon {\n    display: none; /* Initially hide the close icon */\n  }\n  \n  #check:checked ~ .icons .menu-icon {\n    display: none; /* Hide menu icon when checkbox is checked */\n  }\n  \n  #check:checked ~ .icons .closed-icon {\n    display: block; /* Show close icon when checkbox is checked */\n  }\n\n/* ***Breakpoints******* */\n\n@media (max-width: 1200px) {\n    .header {\n      padding: 0.5rem 1%;\n    }\n    .icons {\n      display: inline-flex;\n    }\n    .navbar {\n      position: absolute;\n      left: -100%;\n      top: 0;\n      width: 70%;\n      height: 100vh;\n      display: flex;\n      flex-direction: column;\n      line-height: 40px;\n      background-color: white;\n      transition: 0.9s ease-out;\n    }\n    .btns-login {\n      text-align: center;\n    }\n    .navbar a {\n      border-bottom: 1px solid grey;\n      margin: 0.5rem 0.4rem;\n    }\n    .icons .menu-icon {\n      display: block;\n    }\n    .icons .closed-icon {\n      display: none;\n    }\n    #check:checked ~ .icons .menu-icon {\n      display: none;\n    }\n    #check:checked ~ .icons .closed-icon {\n      display: block;\n    }\n    #check:checked ~ .navbar {\n      left: 0;\n      transition: 0.5s ease;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
